import { PropsWithChildren, ReactElement } from "react";
import { bellState } from "../../bellState";
import "./AttentionIndicator.scss";

interface IProps {
    count: number;
    overdueCount: number;
    unreadCount: number;
}

/**
 * The badge on the bell.
 *
 * The number is what the person has to do; unread notifications get a dot. See
 * bellState for why the two are never added together.
 */
function AttentionIndicator(props: PropsWithChildren<IProps>): ReactElement {
    const { count, overdueCount, unreadCount, children } = props;

    const state = bellState(count, overdueCount, unreadCount, true);

    return (
        <div className="AttentionIndicator">
            {children}

            {state.kind === "dot" && (
                <span className="AttentionIndicator-dot" role="presentation" />
            )}

            {state.kind === "count" && (
                <span
                    className={state.isOverdue
                        ? "AttentionIndicator-count AttentionIndicator-count--late"
                        : "AttentionIndicator-count"}
                    role="presentation"
                >
                    {/* Not capped at "9+". The number is a workload, and somebody
                        with twelve things waiting should be told it is twelve. */}
                    {count}
                </span>
            )}
        </div>
    );
}

export default AttentionIndicator;
